import * as Yup from 'yup/lib'
import { REQUIRED_FIELD_TEXT } from 'modules/SharedSales/constants/validations'

export const DeviceOfferSchema = {
  device: Yup.object({
    id: Yup.string().required(REQUIRED_FIELD_TEXT),
  }),
}
